export const FormInputControls = Object.freeze({
  CLEAR: 'clear',
  SHOW: 'show',
  HIDE: 'hide',
});

export const FormInputTypes = Object.freeze({
  PASSWORD: 'password',
  TEXT: 'text',
  NUMBER: 'tel',
});

export const FormInputNames = Object.freeze({
  EMAIL: 'email',
  PASSWORD: 'password',
  NEW_PASSWORD: 'newPassword',
  CONFIRM_PASSWORD: 'confirmPassword',
  BIRTH_MONTH: 'birthMonth',
  BIRTH_YEAR: 'birthYear',
  BIRTH_DAY: 'birthDay',
  ZIP_CODE: 'zipCode',
  GENDER: 'gender',
  OFFER_CODE: 'offerCode',
  CAPTCHA: 'captcha',
});
